import { Component, OnInit, Input, ViewEncapsulation, AfterViewInit, AfterViewChecked, EventEmitter, Output, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { ComponentesService } from '../componentes.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CampoFormulario, FormularioPrefs } from './interfaces';
import { HttpService } from '../http.service';
import { FocusNextDirective } from '../directives/focus-next.directive';
import { UtilService } from '@app/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-formulario',
	templateUrl: './formulario.component.html',
	styleUrls: ['./formulario.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class Formulario implements OnInit, AfterViewInit, AfterViewChecked {
	constructor(
		private fb: FormBuilder,
		private httpService: HttpService,
		private componentesService: ComponentesService,
		private sanitizer: DomSanitizer
	) {  }

	campos: CampoFormulario[] = [];
	formulario: FormGroup;
	url: string;
	metodo = 'POST';
	resetOnSubmit = true;
	campoID: string;
	focusNextGuardar: Number;
	laravel = false;
	imagen = []; // una forma de saber si la imagen fue cargada
	archivo = []; // una forma de saber si la imagen fue cargada

	@ViewChildren(FocusNextDirective) focusElements: QueryList<FocusNextDirective>;


	/** Permite habilitar o no los botones de Guardar y Cancelar del formulario */
	@Input() btnAcciones = true;
	@Input() errores: any;

	@Output() fnchipChanges = new EventEmitter();
	@Output() fnestablecido = new EventEmitter();
	@Output() fncambiaFecha = new EventEmitter();
	@Output() fncambiaMes = new EventEmitter();
	@Output() fncambiaSelect = new EventEmitter();
	@Output() fnformReset = new EventEmitter();
	@Output() fncambiaInputtext = new EventEmitter();
	@Output() fnclickImagen = new EventEmitter();
	@Output() fndocargaImagen = new EventEmitter();

	antesSubmit: () => Promise<void> = () => Promise.resolve();
	despuesSubmit: () => Promise<void> = () => Promise.resolve();

	ngOnInit() {
		this.formulario = this.fb.group({});
	}

	getForm(): any {
		return this.formulario as any;
	}

	isFromEmpty() {
		return Object.keys(this.formulario.value).length === 0 && this.formulario.value.constructor === Object;
	}

	async ngAfterViewInit() {
		await this.ngAfterViewChecked();
		return;
	}

	async ngAfterViewChecked() {
		return;
	}

	init(datos: FormularioPrefs) {
		return new Promise<void>(resolve => {
			this.ngAfterViewInit().then(() => {
				for (const key in datos) {
					if (datos.hasOwnProperty(key)) {
						this[key] = datos[key];
					}
				}

/*
				if (datos.metodo) {
					this.metodo = datos.metodo;
				}

				if (datos.resetOnSubmit != undefined && datos.resetOnSubmit != null) {
					this.resetOnSubmit = datos.resetOnSubmit;
				}

				if (datos.antesSubmit) {
					this.antesSubmit = datos.antesSubmit;
				}

				if (datos.despuesSubmit) {
					this.despuesSubmit = datos.despuesSubmit;
				}

				if (datos.focusNextGuardar) {
					this.focusNextGuardar = datos.focusNextGuardar;
				}

				if (datos.laravel) {
					this.laravel = datos.laravel;
				}

				this.campoID = datos.campoID;
				this.url = datos.url;
				this.campos = datos.campos;
*/
				// limpiamos el formulario y volvemos a cargar por si se modifico
				this.formulario = this.fb.group({});
				setTimeout(() => {
					if (this.campos && this.campos.length > 0) {
						for (let i = 0; i < this.campos.length; i++) {
							this.formulario.addControl(this.campos[i].name, new FormControl(null));
							this.formulario.get(this.campos[i].name)['tipo'] = this.campos[i].tipo;
							this.formulario.get(this.campos[i].name)['attrs'] = this.campos[i].attrs;
							if (this.campos[i].validadores) {
								this.formulario.get(this.campos[i].name).setValidators(this.campos[i].validadores);
							}
						}
					}
				}, 50);
				setTimeout(() => {
					const ele = this.focusElements.find(f => f.tabIndex === Math.min(...this.focusElements.map(f => f.tabIndex)));
					if (ele) {
						ele.focus();
					}
					resolve();
				}, 75);
			});
		});
	}

	onSubmit() {
		return new Promise(resolve => {

			// fix valor string cero
			for (const campo in this.formulario.value) {
				if (this.formulario.get(campo)['tipo'] == 'toggle' || this.formulario.get(campo)['tipo'] == 'checkbox') {
					this.formulario.get(campo).patchValue((this.formulario.get(campo).value == undefined || this.formulario.get(campo).value == null || this.formulario.get(campo).value == 0) ? false : this.formulario.get(campo).value);
				}
			}

			this.antesSubmit().then( () => {
				let uri = '';
				let method = 'post';
				let data = {};

				if (this.url && this.url != '') {
					if (this.laravel) {
						if (this.formulario.get(this.campoID).value) {
							uri = this.url + '/' + this.formulario.value[this.campoID];
							data = this.formulario.value;
							method = 'put';
						} else {
							uri = this.url;
							data = this.formulario.value;
							method = 'post';
						}
					} else {
						uri = this.url;
						method = 'post';
						data = { campoID: this.campoID, datos: this.formulario.value };
					}
					(method === 'post' ? this.httpService.post(uri, data) : this.httpService.put(uri, data)).then((data) => {
						if ((data.ok && data.ok === 1) || data.success) {
							// mostramos notificacion de exito
							this.componentesService.notification('Datos guardados satisfactoriamente.');
							// funcion despues de enviado el formulario
							this.despuesSubmit().then(() => {
								// limpiamos el formulario
								if (this.resetOnSubmit) {
									this.reset();
								}
								setTimeout(() => {
									const ele = this.focusElements.find(f => f.tabIndex === Math.min(...this.focusElements.map(f => f.tabIndex)));
									if (ele) {
										ele.focus();
									}
								}, 700);
								resolve(true);
							})
							.catch( (e) => {
								console.log('Despues Submit', e);
							});
						} else {
							// mostramos notificacion de fallo
							this.componentesService.notification((data.msg) ? data.msg : 'Error al guardar los datos.');
							resolve(false);
						}
					})
					.catch((e) => {
						console.log(e);
						// mostramos notificacion de fallo
						this.componentesService.notification('Error al guardar los datos.');
						resolve(false);
					});
				} else {
					this.despuesSubmit().then(() => {
						// limpiamos el formulario
						if (this.resetOnSubmit) {
							this.reset();
						}

						setTimeout(() => {
							const ele = this.focusElements.find(f => f.tabIndex === Math.min(...this.focusElements.map(f => f.tabIndex)));
							if (ele) {
								ele.focus();
							}
						}, 700);

						resolve(false);
					})
					.catch ((e) => {
						console.log('Despues submit', e);
					});
				}
			})
			.catch((e) => {
				// console.log('Antes Submit', e);
			});
		});
	}

	cargaDatos(datos: any) {
		if (datos) {
			for (const campo in datos) {
				if (this.formulario.get(campo)) {
					// fix valor string cero
					if (this.formulario.get(campo)['tipo'] == 'toggle' || this.formulario.get(campo)['tipo'] == 'checkbox') {
						datos[campo] = (datos[campo] == '0' || datos[campo] == 0) ? false : datos[campo];
					}
					this.formulario.get(campo).patchValue(datos[campo]);
				}
			}
			this.campos.filter(campo => campo.tipo == 'imgupload').forEach(filtrado => {
				if (filtrado.tipo == 'imgupload' && filtrado.attrs && filtrado.attrs.urlimagen && datos[filtrado.attrs.urlimagen] && datos[filtrado.attrs.urlimagen].length > 1) {
					const urlimagen = datos[filtrado.attrs.urlimagen];
					this.httpService.leeUrl(urlimagen).then(result => {
						const unsafeImageUrl = URL.createObjectURL(result);
						const imageUrl = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
						this.imagen[filtrado.name] = [imageUrl, urlimagen];
						this.fndocargaImagen.emit({
							datos: urlimagen,
							dequien: filtrado.name,
							imagen: imageUrl,
							tipo: 'url'
						});
					});
				} else if (filtrado.tipo == 'imgupload' && datos[filtrado.attrs.urlimagen] === null) {
					this.imagen[filtrado.name] = null;
					this.fndocargaImagen.emit({
						datos: null,
						dequien: filtrado.name,
						imagen: null,
						tipo: null
					});

				}
			});
		}
	}

	clickImagen(e, imagenInput, dequien) {
		imagenInput.click();
		this.fnclickImagen.emit({
			event: e,
			dequien: dequien
		});
	}

	docargaImagen(e, dequien) {
		this.httpService.leeArchivo(e.target, 'dataurl', () => {
			this.componentesService.notification('Error al cargar la imagen');
		}).then ( result => {
			this.imagen[dequien] = [result, e.target.files[0]];
			this.fndocargaImagen.emit({
				datos: e.target.files[0],
				dequien: dequien,
				imagen: result,
				tipo: 'blob'
			});
		});
	}


	docargaArchivo(e, dequien) {
		
		this.httpService.leeArchivo(e.target, 'dataurl', () => {
			this.componentesService.notification('Error al cargar el archivo');
		}).then(result => {
			this.archivo[dequien] = [result, e.target.files[0]];
			this.fndocargaImagen.emit({
				datos: e.target.files[0],
				dequien: dequien,
				archivo: result,
				tipo: 'blob'
			});
		});
		
	}

	borraArchivo(e, dequien) {
		this.archivo[dequien] = null;
		this.fndocargaImagen.emit({
			datos: null,
			dequien: dequien,
			archivo: null,
			tipo: null
		});
	}
	
	borraImagen(e, dequien) {
		this.imagen[dequien] = null;
		this.fndocargaImagen.emit({
			datos: null,
			dequien: dequien,
			imagen: null,
			tipo: null
		});
	}

	reset(event = null) {
		this.formulario.reset();
		this.campos.filter(campo => campo.tipo == 'imgupload').forEach(filtrado => {
			if (this.imagen[filtrado.name]) {
				this.imagen[filtrado.name] = null;
			}
		});
		this.campos.filter(campo => campo.tipo == 'fileUpload').forEach(filtrado => {
			if (this.archivo[filtrado.name]) {
				this.archivo[filtrado.name] = null;
			}
		});
		this.fnformReset.emit(event);
	}
	establecer(e, dequien) {
		this.fnestablecido.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerChip(e, dequien) {
		this.fnchipChanges.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerFecha(e, dequien) {
		this.fncambiaFecha.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerMes(e, dequien) {
		this.formulario.get(dequien).patchValue({ 'desde': e.desde, 'hasta': e.hasta });
		this.fncambiaMes.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerSelect(e, dequien) {
		this.fncambiaSelect.emit({
			event: e,
			dequien: dequien
		});
	}
	establecerInputtext(e, dequien) {
		this.fncambiaInputtext.emit({
			event: e,
			dequien: dequien
		});
	}

	get keys() {
		return Object.keys(this.formulario.controls);
	}

	getErrorMessage(name) {
		if (this.formulario.get(name).invalid) {
			if (this.errores) {
				for (const key in this.errores) {
					if (this.formulario.get(name).errors && this.formulario.get(name).errors.hasOwnProperty(key)) {
						return this.errores[key];
					}
				}
			}
			return 'El campo ' + this.formulario.get(name)['attrs'].placeholder + ' es inválido';
		}
	}

	t(e) {
		if (e.keyCode == 13) {
			this.onSubmit();
		}
	}

	getControl(controlName): any {
		return (this.formulario as any).controls[controlName];
	}


	getControlAttr(controlName,attr): any{
		return this.getControl(controlName).attrs[attr]; 
	}

	setControlAttr(controlName, attr,newAtrr): any{
		return this.getControl(controlName).attrs[attr] = newAtrr; 

	}

}
